import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiService } from '../../services/apiService';

export const fetchPartMakes = createAsyncThunk(
    'partMakes/fetchPartMakes',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.getPartMakesPaginated(params);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch part makes');
        }
    }
);

export const getPartMakesOverview = createAsyncThunk(
    'partMakes/getPartMakesOverview',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.getPartMakesOverview();
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch part makes overview');
        }
    }
);

export const createPartMakeAsync = createAsyncThunk(
    'partMakes/createPartMake',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await apiService.createPartMake(payload);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to create part make');
        }
    }
);

export const updatePartMakeAsync = createAsyncThunk(
    'partMakes/updatePartMake',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await apiService.updatePartMake(payload);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to update part make');
        }
    }
);

export const deletePartMakeAsync = createAsyncThunk(
    'partMakes/deletePartMake',
    async (id, { rejectWithValue }) => {
        try {
            const response = await apiService.deletePartMake(id);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to delete part make');
        }
    }
);

const initialState = {
    partMakesData: null,
    partMakesLoading: false,
    partMakesError: null,
    partMakesOverview: null,
    partMakesOverviewLoading: false,
    createPartMakeLoading: false,
    updatePartMakeLoading: false,
    deletePartMakeLoading: false,
};

const partMakeSlice = createSlice({
    name: 'partMakes',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPartMakes.pending, (state) => {
                state.partMakesLoading = true;
                state.partMakesError = null;
            })
            .addCase(fetchPartMakes.fulfilled, (state, action) => {
                state.partMakesLoading = false;
                state.partMakesData = action.payload?.data || null;
                state.partMakesError = null;
            })
            .addCase(fetchPartMakes.rejected, (state, action) => {
                state.partMakesLoading = false;
                state.partMakesError = action.payload;
                state.partMakesData = null;
            })
            .addCase(getPartMakesOverview.pending, (state) => {
                state.partMakesOverviewLoading = true;
            })
            .addCase(getPartMakesOverview.fulfilled, (state, action) => {
                state.partMakesOverviewLoading = false;
                state.partMakesOverview = action.payload?.data || null;
            })
            .addCase(getPartMakesOverview.rejected, (state) => {
                state.partMakesOverviewLoading = false;
            })
            .addCase(createPartMakeAsync.pending, (state) => {
                state.createPartMakeLoading = true;
            })
            .addCase(createPartMakeAsync.fulfilled, (state) => {
                state.createPartMakeLoading = false;
            })
            .addCase(createPartMakeAsync.rejected, (state) => {
                state.createPartMakeLoading = false;
            })
            .addCase(updatePartMakeAsync.pending, (state) => {
                state.updatePartMakeLoading = true;
            })
            .addCase(updatePartMakeAsync.fulfilled, (state) => {
                state.updatePartMakeLoading = false;
            })
            .addCase(updatePartMakeAsync.rejected, (state) => {
                state.updatePartMakeLoading = false;
            })
            .addCase(deletePartMakeAsync.pending, (state) => {
                state.deletePartMakeLoading = true;
            })
            .addCase(deletePartMakeAsync.fulfilled, (state) => {
                state.deletePartMakeLoading = false;
            })
            .addCase(deletePartMakeAsync.rejected, (state) => {
                state.deletePartMakeLoading = false;
            });
    },
});

export default partMakeSlice.reducer;
